import axiosInstance from "../Interceptor";

export const getUsersAnalyticsApi = (data) => {
  //   console.log(data, 'from api');


  return axiosInstance
    .get(`users/api/v1/regional_admin/${data}/`)
    .then((res) => {
      // console.log(res);
      return res;
    })
    .catch((err) => {
   
      return err;
    });
};
